export default __webpack_public_path__ + "static/media/aguardando-transferencia.b6a551f7.mp3";